import {
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  VStack,
} from "@chakra-ui/react";
import TimTuyenDuongForm from "../containers/TimTuyenDuongForm";
import RanhGioiTuyenDuongForm from "../containers/RanhGioiDuongForm";

interface IProps {
  type: string;
  isTimTuyenDuong?: boolean;
}
export default function TimRanhGioiTuyenDuong({
  type,
  isTimTuyenDuong,
}: IProps) {
  return (
    <Flex w="full" bg="whiteAlpha.900">
      <Card w="50%" alignSelf="center" margin="20px auto" bg="#f1f1f1">
        <CardHeader alignItems="center" display="flex" justifyContent="center">
          <Heading as="h3" color="gray.700" textTransform="uppercase">
            {type}
          </Heading>
        </CardHeader>
        <CardBody>
          {/* {!isTimTuyenDuong && <UploadFile title={type} />} */}
          {isTimTuyenDuong && (
            <VStack w="full">
              <TimTuyenDuongForm />
            </VStack>
          )}
          {!isTimTuyenDuong && (
            <VStack w="full">
              <RanhGioiTuyenDuongForm />
            </VStack>
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}
